module.exports = __webpack_public_path__ + "img/lemonade.80c908ba.png";